import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SEO from '@/components/feature/SEO';
import TechImagePanel from '@/components/feature/TechImagePanel';
import Hero from './components/Hero';
import Ledger from './components/Ledger';

export default function Settlement() {
  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <SEO
        title="九畴云铺透明清分账本 | 七方共利价值分配引擎"
        description="九畴云铺透明清分账本，以动态账本记录商品交易用户推荐服务供应链平台清分对账的每一环，七方共利智能清分实现可追溯可对账的价值分配。"
        keywords="九畴云铺,透明账本,智能清分,七方共利,价值分配,对账"
        path="/jiuchou/settlement"
        jsonLd={{
          '@context': 'https://schema.org',
          '@type': 'WebPage',
          name: '九畴云铺透明清分账本',
          description: '七方共利价值分配引擎',
        }}
      />
      <main>
        <Hero />
        <TechImagePanel
          eyebrow="价值分配"
          title="七方共利，可追溯、可对账"
          desc="订单、贡献、规则、计算、清分、对账，透明账本记录每一笔价值的来源与去向。"
          chips={['订单', '贡献识别', '智能计算', '对账', '冲正']}
          stats={[
            { value: '7 方', label: '共利分配' },
            { value: '0 差错', label: '目标指标' },
            { value: '100%', label: '对账一致' },
          ]}
          imageUrl="https://readdy.ai/api/search-image?query=Abstract%20transparent%20settlement%20ledger%20grid%2C%20deep%20dark%20ink%20navy%20background%2C%20glowing%20emerald%20and%20gold%20data%20rows%20and%20value%20streams%20flowing%20through%20ledger%20blocks%2C%20seven%20party%20value%20distribution%2C%20futuristic%20financial%20clarity%2C%20minimal%20geometric%20composition%2C%20cinematic%20lighting%2C%20high%20detail&width=1600&height=900&seq=jiuchou-panel-settle&orientation=landscape"
          imageAlt="九畴云铺 七方共利价值分配"
        />
        <Ledger />
      </main>
      <Footer />
    </div>
  );
}